import React from 'react'

const PageNotFound = () => {
  return <div>page not found</div>
}

export { PageNotFound }
